import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    frameId: String,
    modalBoxClasses: { type: String, default: "" },
    modalClasses: { type: String, default: "" },
  };

  initialize() {
    this.url = this.element.getAttribute("href");
  }

  open(event) {
    event.preventDefault();
    const { dialog, frame } = this.insertContainer();
    this.dialog = dialog;
    this.frame = frame;

    this.addEventListeners();
    this.dialog.showModal();
  }

  close() {
    this.dialog.close();
    this.dialog.remove();
  }

  addEventListeners() {
    this.dialog.addEventListener("click", this.handleDialogClick.bind(this));

    this.frame.addEventListener("turbo:frame-load", this.handleFrameLoad.bind(this));
  }

  insertContainer() {
    const content = `
      <dialog class="du-modal ${this.modalClassesValue}" id="dialog_${this.frameIdValue}">
        <div class="du-modal-box ${this.modalBoxClassesValue}">
          <button type="button" class="du-btn du-btn-sm du-btn-circle du-btn-ghost absolute right-2 top-2" data-behavior="cancel" autofocus>
            <i class="icon-x pointer-events-none"></i>
          </button>
          <div class="mt-5">
            <turbo-frame id="${this.frameIdValue}" src="${this.url}">
              <div class="flex justify-center my-5">
                <i class="du-loading du-loading-dots du-loading-sm"></i>
              </div>
            </turbo-frame>
          </div>
        </div
      </dialog>
    `;

    document.body.insertAdjacentHTML('beforeend', content);
    document.activeElement.blur();

    const dialog = document.getElementById(`dialog_${this.frameIdValue}`);
    const frame = document.getElementById(this.frameIdValue);
    return { dialog: dialog, frame: frame };
  }

  handleDialogClick(event) {
    if (event.target.hasAttribute("data-behavior") && event.target.getAttribute("data-behavior") === "cancel") {
      event.preventDefault();
      this.close();
    }
  }

  handleFrameLoad(event) {
    const close_form = this.frame.querySelector("form[data-behavior=cancel]")
    if(close_form) {
      close_form.addEventListener("turbo:submit-end", (event) => {
        if(event.detail.success) {
          this.close();
        }
      });
    }
  }

  disconnect() {
    if (this.dialog) {
      this.dialog.removeEventListener("click", this.handleDialogClick.bind(this));
      this.frame.removeEventListener("turbo:frame-load", this.handleFrameLoad.bind(this));
      this.dialog.remove();
    }
  }
}
